<template>
    <Breadcrumbs main="Animation" title="AOS Animation" />
    <div class="container-fluid">
        <div class="row">
            <aosExample />
            <initAOS />
            <animationView />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const aosExample = defineAsyncComponent(() => import("@/components/theme/animation/aos/aosExample.vue"))
const initAOS = defineAsyncComponent(() => import("@/components/theme/animation/aos/initAOS.vue"))
const animationView = defineAsyncComponent(() => import("@/components/theme/animation/aos/animationView.vue"))
</script>